import { useActivitiesInvalidate } from "PFCore/hooks/queries/activities/use_activities_invalidate";
import React, { useEffect } from "react";

import { MarketplacePage as MarketplacePageEnum } from "./constants/marketplace_page";
import { useMarketplaceContext } from "./contexts/marketplace_context";
import { Dashboard } from "./dashboard";
import { AddSkillModal } from "./modals/add_skill_modal";
import { EditPreferencesModal } from "./modals/edit_preferences_modal";
import { WorkOpportunities } from "./work_opportunities";

type MarketplacePageProps = {
  page: MarketplacePageEnum;
};

export const MarketplacePage = ({ page }: MarketplacePageProps): JSX.Element => {
  const { modal } = useMarketplaceContext();
  const { invalidateByCollection } = useActivitiesInvalidate();

  useEffect(
    () => () => {
      setTimeout(() => invalidateByCollection(), 100);
    },
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return (
    <div>
      {page === MarketplacePageEnum.Dashboard && <Dashboard />}
      {page === MarketplacePageEnum.WorkOpportunities && <WorkOpportunities />}
      {modal.type === "editPreferences" && <EditPreferencesModal />}
      {modal.type === "addSkill" && <AddSkillModal />}
    </div>
  );
};
